export const getCacheKey = (table, tag, name, value = []) => {
    return table + ':' + tag + ':' + name + (value.length ? '-' + value.join('-') : '');
}